// banner 配置
export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1exgPxhn1gK0jSZKPXXXvUXXa-1920-757.jpg',
  mcover: 'https://gw.alicdn.com/tfs/TB1PbycM7voK1RjSZFNXXcxMVXa-750-320.png',
  title: {
    loginTitle: '科技让健康触手可及',
    text: '浙江扁鹊健康科技有限公司',
  },
};
